<div class="account-pages my-5 pt-5">
  <div class="container">
    <!-- Step Progress Indicator -->
    <div class="row justify-content-center mb-4">
      <div class="col-lg-10">
        <div class="card shadow-sm border-0" style="background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);">
          <div class="card-body py-3 px-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <small class="text-white-50 text-uppercase fw-semibold">Onboarding Progress</small>
                <h6 class="mb-0 mt-1">
                  <span class="text-white">Step {{ currentStep }} </span>
                  <span class="text-white">of {{ totalSteps }}</span>
                </h6>
              </div>
              <div class="text-end">
                <span class="badge bg-white font-size-12 px-3 py-2" style="color: #f97316;">
                  <i class="bx bx-message-square-dots me-1"></i> Final Step
                </span>
              </div>
            </div>
            <div class="progress" style="height: 8px; border-radius: 10px; background-color: rgba(255, 255, 255, 0.2);">
              <div class="progress-bar bg-white" 
                   role="progressbar" 
                   [style.width.%]="progressPercentage"
                   [attr.aria-valuenow]="progressPercentage" 
                   aria-valuemin="0" 
                   aria-valuemax="100"
                   style="border-radius: 10px; transition: width 0.6s ease;">
              </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <small class="text-white-50">
                <i class="bx bx-loader bx-spin me-1"></i>Messaging Configuration
              </small>
              <small class="text-white-50 font-size-11">{{ progressPercentage }}% Complete</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <!-- Main Setup Card -->
      <div class="col-lg-6">
        <div class="card overflow-hidden shadow-sm border-0">
          <div style="background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);">
            <div class="text-center p-4">
              <div class="d-flex align-items-center justify-content-center">
                <i class="bx bx-message-square-dots font-size-32 text-white me-3"></i>
                <div class="text-start">
                  <h5 class="text-white font-size-20 mb-1">Messaging Limits</h5>
                  <p class="text-white-50 mb-0">Control how many WhatsApp messages your organization can send each month.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body p-4">
            <div class="p-3">
              @if (isLoading) {
                <div class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-2 text-muted">Loading configuration...</p>
                </div>
              } @else {
                <!-- Messaging Limits Form -->
                <div class="mb-4">
                  <h6 class="mb-3">
                    <i class="bx bx-slider-alt me-2" style="color: #f97316;"></i>
                    Configure Limits:
                  </h6>
                  @for (cat of categories; track cat.key) {
                    <div class="border rounded p-3 mb-3 shadow-sm" style="background-color: #fafafa;">
                      <div class="d-flex align-items-center mb-2">
                        <i class="bx {{ cat.icon }} font-size-20 me-2" style="color: #f97316;"></i>
                        <div>
                          <h6 class="mb-0">{{ cat.label }}</h6>
                          <small class="text-muted">{{ cat.description }}</small>
                        </div>
                      </div>
                      <div class="row g-2 mt-1">
                        <div class="col-sm-6">
                          <label class="form-label font-size-12 text-muted mb-1">Monthly Limit <span class="text-muted fw-normal">(# of messages)</span></label>
                          <input 
                            type="number" 
                            class="form-control" 
                            [ngModel]="limits[cat.key].limit"
                            (ngModelChange)="limits[cat.key].limit = $event === '' ? null : +$event"
                            placeholder="Unlimited"
                            min="0">
                        </div>
                        <div class="col-sm-6">
                          <label class="form-label font-size-12 text-muted mb-1">When Limit Reached</label>
                          <select class="form-select" [(ngModel)]="limits[cat.key].action">
                            <option value="none">Do Nothing</option>
                            <option value="notify">Notify Admins</option>
                            <option value="block">Block Sending</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <div class="alert alert-info border-0 shadow-sm mb-4" role="alert">
                  <div class="d-flex align-items-start">
                    <div class="flex-shrink-0 me-3">
                      <i class="bx bx-info-circle font-size-20"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-1 font-size-14">Flexible Limits</h6>
                      <p class="mb-0 font-size-13">
                        Leave a field empty for unlimited messages in that category. You can change these limits anytime from Settings.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="d-grid gap-2">
                  <button 
                    type="button" 
                    class="btn btn-lg waves-effect waves-light shadow-sm"
                    style="background-color: #f97316; border-color: #f97316; color: white; padding: 12px; font-size: 16px;"
                    (click)="saveAndContinue()"
                    [disabled]="isSaving">
                    @if (isSaving) {
                      <span><i class="bx bx-loader bx-spin me-2"></i>Saving...</span>
                    } @else {
                      <span><i class="bx bx-check me-2"></i><span class="fw-semibold">Save & Continue to Dashboard</span></span>
                    }
                  </button>

                  <button 
                    type="button" 
                    class="btn btn-outline-secondary waves-effect"
                    (click)="skip()">
                    Skip - I'll Set This Up Later
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Help Section -->
      <div class="col-lg-6">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="text-center mb-4">
              <div class="avatar-md mx-auto mb-3">
                <div class="avatar-title rounded-circle" style="background-color: rgba(249, 115, 22, 0.1); color: #f97316;">
                  <i class="bx bx-help-circle font-size-24"></i>
                </div>
              </div>
              <h5 class="mb-1">Help & FAQ</h5>
              <p class="text-muted font-size-13 mb-0">Common questions answered</p>
            </div>

            <div class="card border mb-3 feature-card">
              <div class="card-body p-3">
                <h6 class="mb-2"><i class="bx bx-dollar-circle text-warning me-2"></i> Why Set Limits?</h6>
                <p class="text-muted font-size-13 mb-0">
                  WhatsApp charges <strong>per message delivered</strong> — not per message sent. Setting monthly limits 
                  helps your organization control spending and prevents unexpected billing surprises.
                </p>
              </div>
            </div>

            <div class="card border mb-3 feature-card">
              <div class="card-body p-3">
                <h6 class="mb-2"><i class="bx bx-heart text-danger me-2"></i> No Markup from Echo</h6>
                <p class="text-muted font-size-13 mb-0">
                  Your payment method is linked directly to your WhatsApp Business Account in Meta Business Manager. 
                  This means you pay Meta's base rate for every message — Echo does not add any markup or take any 
                  profit from your messaging costs.
                </p>
              </div>
            </div>

            <div class="card border mb-3 feature-card">
              <div class="card-body p-3">
                <h6 class="mb-2"><i class="bx bx-category text-info me-2"></i> Message Categories</h6>
                <ul class="text-muted font-size-13 ps-3 mb-0">
                  <li class="mb-1"><strong>Marketing</strong> — Promotional messages, offers, newsletters</li>
                  <li class="mb-1"><strong>Utility</strong> — Transactional updates, reminders, alerts</li>
                </ul>
              </div>
            </div>

            <div class="card border mb-0 feature-card">
              <div class="card-body p-3">
                <h6 class="mb-2" style="color: #f97316;"><i class="bx bx-shield-alt-2 me-2"></i> Actions When Limit Reached</h6>
                <ul class="text-muted font-size-13 ps-3 mb-0">
                  <li class="mb-1"><strong>Do Nothing</strong> — Messages continue; limit is for tracking only</li>
                  <li class="mb-1"><strong>Notify Admins</strong> — Admins receive an alert when the limit is hit</li>
                  <li class="mb-1"><strong>Block Sending</strong> — No more messages can be sent in that category until next month or until the limit has been readjusted</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
